export const FETCH_PAGE = 'FETCH_PAGE';
export const SAVE_PAGE = 'SAVE_PAGE';
export const PUBLISH_PAGE = 'PUBLISH_PAGE';
